<template>
  <el-dialog
    title="退款申请处理"
    :visible="visible"
    :close-on-click-modal="false"
    width="500px"
    top="8vh"
    @close="onDialogClose"
    append-to-body
  >
    <div class="process-dialog-content">
      <el-form
        :model="formModel"
        :rules="rules"
        ref="processForm"
        size="small"
        label-width="90px"
      >
        <el-form-item label="订单编号: ">
          <span>{{ refundDetail.outTradeNo }}</span>
          <el-button
            type="text"
            size="small"
            style="margin-left: 10px;"
            @click="viewOrder"
            v-if="refundDetail.outTradeNo"
          >查看订单</el-button>
        </el-form-item>
        <el-form-item label="支付金额: ">
          <span>{{ (refundDetail.totalPayFee / 100) || '-' }}元</span>
        </el-form-item>
        <el-form-item label="退款方式: ">
          <span>{{ refundDetail.refundFunText || '-' }}</span>
        </el-form-item>
        <el-form-item label="退款金额: ">
          <span>{{ (refundDetail.refundAmount / 100) || '-' }}元</span>
        </el-form-item>
        <el-form-item label="退款原因: ">
          <el-input
            :value="refundDetail.refundReason"
            disabled
            readonly
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
          />
        </el-form-item>
        <el-form-item label="申请人: ">
          <span>{{ refundDetail.refundApplyUser }}</span>
        </el-form-item>
        <el-form-item label="申请时间: ">
          <span>{{ refundDetail.createTime }}</span>
        </el-form-item>
        <el-form-item label="处理意见: " prop="mark">
          <el-input
            v-model="formModel.mark"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入处理意见"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        size="small"
        type="primary"
        @click="handleResult('agree')"
      >同 意</el-button>
      <el-button
        size="small"
        type="warning"
        @click="handleResult('reject')"
      >拒 绝</el-button>
      <el-button size="small" @click="onDialogClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { agreeRefund, rejectRefund } from '@/api/memberNew/terminal'

export default {
  name: 'TerminalProcessDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    refundDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formModel: {
        mark: ''
      },
      rules: {
        mark: [
          { required: true, message: '请输入处理意见', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    onDialogClose() {
      this.$emit('update:visible', false);
      this.$refs.processForm.resetFields();
    },
    viewOrder() {
      this.onDialogClose()
      this.$router.push({
        path: '/memberNew/terminalOrder/index',
        query: {
          outTradeNo: this.refundDetail.outTradeNo
        }
      })
    },
    handleResult(type) {
      this.$refs.processForm.validate(valid => {
        if (valid) {
          const { id } = this.refundDetail
          const params = {
            id,
            mark: this.formModel.mark
          }
          
          const api = type === 'agree' ? agreeRefund : rejectRefund
          const msg = type === 'agree' ? '已同意退款' : '已拒绝退款'
          
          api(params).then(res => {
            if (res.data && res.data.code === 200) {
               this.$message.success(msg);
               this.$emit('success');
               this.onDialogClose();
            } else {
               this.$message.error(res.data.msg || '操作失败');
            }
          })
        }
      })
    }
  }
};
</script>
